import { TOrderCategorySlug } from '@/common/integrations/menhir/employee/orders/orders.types';
import { useLocalSearchParams, useRouter } from 'expo-router';
import { ReimbursementDetaiDrawer } from './ReimbursementDetailDrawer/ReimbursementDetaiDrawer';

export const MovementDetail = () => {
  const { setParams } = useRouter();
  const queryParams = useLocalSearchParams<{
    orderId: string;
    categorySlug: string;
  }>();
  const closeDrawer = () => {
    setParams({ orderId: '', categorySlug: '' });
  };
  if (queryParams?.orderId && queryParams.categorySlug) {
    return (
      <ReimbursementDetaiDrawer
        orderId={queryParams.orderId}
        categorySlug={queryParams.categorySlug as TOrderCategorySlug}
        onClose={closeDrawer}
      />
    );
  }
  return null;
};
